export const BASE_PATH_DOCUMENTS = 'api/App/documents/';
